import React, { useEffect, useState } from 'react';
import api, { API_BASE } from '../services/api';

const TABS = [
  { id: 'empresa', label: '🏢 Empresa' },
  { id: 'dian',    label: '📄 DIAN / Factura Electrónica' },
  { id: 'correo',  label: '✉️ Correo / SMTP' },
  { id: 'recepcion', label: '📥 Recepción DIAN' },
  { id: 'general', label: '⚙️ General' },
];

const INIT = {
  empresa_nombre: '', empresa_nit: '', empresa_direccion: '',
  empresa_telefono: '', empresa_email: '', empresa_ciudad: '',
  empresa_logo_url: '', empresa_slogan: '',
  empresa_regimen: 'Responsable de IVA', empresa_tipo_persona: 'juridica',
  empresa_ciiu: '', empresa_responsabilidades: 'O-13;O-15', empresa_actividad_desc: '', empresa_ica_tarifa: '',
  software_id: '', software_pin: '', fe_clave_tecnica: '',
  resolucion_numero: '', resolucion_fecha: '', resolucion_prefijo: '',
  resolucion_desde: 1, resolucion_hasta: 9999,
  resolucion_fecha_desde: '', resolucion_fecha_hasta: '',
  fe_ambiente: '2',
  smtp_host: 'smtp.gmail.com', smtp_port: 587,
  smtp_user: '', smtp_pass: '', smtp_from: '',
  moneda: 'COP', iva_porcentaje: 19, site_url: '',
  plazo_pago_dias: 30, condiciones_comerciales: '',
};

export default function Configuracion() {
  const [tab,      setTab]      = useState('empresa');
  const [form,     setForm]     = useState(INIT);
  const [loading,  setLoading]  = useState(true);
  const [saving,   setSaving]   = useState(false);
  const [msg,      setMsg]      = useState(null); // { ok, text }
  const [testing,  setTesting]  = useState(false);
  const [testMsg,  setTestMsg]  = useState(null);
  const [certMeta, setCertMeta] = useState(null);   // { cargado, meta }
  const [certPass, setCertPass] = useState('');
  const [certFile, setCertFile] = useState(null);
  const [certMsg,  setCertMsg]  = useState(null);
  const [subiendoCert, setSubiendoCert] = useState(false);

  const cargarCertMeta = () => api.get('/dian/cert').then(r => setCertMeta(r.data)).catch(() => setCertMeta({ cargado: false }));

  useEffect(() => {
    api.get('/configuracion')
      .then(r => {
        setForm(f => ({ ...f, ...r.data }));
        // Persiste datos empresa en localStorage para uso en PDFs
        guardarEmpresaLocal(r.data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
    cargarCertMeta();
  }, []);

  const handleSubirCert = async () => {
    if (!certFile) return setCertMsg({ ok: false, text: 'Seleccioná el archivo .p12' });
    if (!certPass) return setCertMsg({ ok: false, text: 'Ingresá la contraseña del certificado' });
    setSubiendoCert(true); setCertMsg(null);
    try {
      const fd = new FormData();
      fd.append('cert', certFile);
      fd.append('password', certPass);
      await api.post('/dian/cert', fd);
      setCertMsg({ ok: true, text: '✅ Certificado cargado y validado' });
      setCertFile(null); setCertPass('');
      cargarCertMeta();
    } catch (e) {
      setCertMsg({ ok: false, text: '❌ ' + (e.response?.data?.error || 'Error al cargar el certificado') });
    } finally { setSubiendoCert(false); }
  };

  const [sincronizando, setSincronizando] = useState(false);
  const [syncMsg, setSyncMsg] = useState(null);
  const handleSincronizar = async () => {
    setSincronizando(true); setSyncMsg(null);
    try {
      const { data } = await api.post('/dian/sincronizar-resolucion');
      const a = data.aplicada || {};
      setForm(f => ({ ...f,
        resolucion_numero: a.resolucion_numero || f.resolucion_numero,
        resolucion_prefijo: a.resolucion_prefijo || f.resolucion_prefijo,
        resolucion_desde: a.resolucion_desde || f.resolucion_desde,
        resolucion_hasta: a.resolucion_hasta || f.resolucion_hasta,
        resolucion_fecha: (a.resolucion_fecha || '').slice(0, 10) || f.resolucion_fecha,
        resolucion_fecha_desde: (a.resolucion_fecha_desde || '').slice(0, 10) || f.resolucion_fecha_desde,
        resolucion_fecha_hasta: (a.resolucion_fecha_hasta || '').slice(0, 10) || f.resolucion_fecha_hasta,
        fe_clave_tecnica: a.fe_clave_tecnica || f.fe_clave_tecnica,
      }));
      setSyncMsg({ ok: true, text: `✅ Resolución sincronizada: ${a.resolucion_prefijo || ''} ${a.resolucion_numero || ''} (${data.rangos?.length || 1} encontrada(s))` });
      cargarProximo();
    } catch (e) {
      setSyncMsg({ ok: false, text: '❌ ' + (e.response?.data?.error || 'No se pudo sincronizar con la DIAN') });
    } finally { setSincronizando(false); }
  };

  // ── Próximo consecutivo de factura ───────────────────────────────────────
  const [proxNum, setProxNum]     = useState(null);   // { prefijo, desde, hasta, proximo, enRango }
  const [proxInput, setProxInput] = useState('');
  const [proxSaving, setProxSaving] = useState(false);
  const [proxMsg, setProxMsg]     = useState(null);
  const cargarProximo = () => api.get('/dian/proximo-numero')
    .then(r => { setProxNum(r.data); setProxInput(String(r.data.proximo ?? r.data.desde ?? '')); })
    .catch(() => {});
  useEffect(() => { cargarProximo(); }, []);
  const guardarProximo = async () => {
    setProxSaving(true); setProxMsg(null);
    try {
      const { data } = await api.put('/dian/proximo-numero', { proximo: parseInt(proxInput, 10) });
      setProxMsg({ ok: true, text: `✅ La próxima factura será ${proxNum?.prefijo || ''}-${data.proximo}` });
      cargarProximo();
    } catch (e) {
      setProxMsg({ ok: false, text: '❌ ' + (e.response?.data?.error || 'No se pudo fijar el número') });
    } finally { setProxSaving(false); }
  };

  const guardarEmpresaLocal = (data) => {
    try {
      localStorage.setItem('erp_empresa', JSON.stringify({
        empresa_nombre:            data.empresa_nombre            || 'ERP Ingeniería',
        empresa_nit:               data.empresa_nit               || '',
        empresa_slogan:            data.empresa_slogan            || 'Soluciones de ingeniería',
        empresa_telefono:          data.empresa_telefono          || '',
        empresa_email:             data.empresa_email             || '',
        empresa_ciudad:            data.empresa_ciudad            || '',
        empresa_direccion:         data.empresa_direccion         || '',
        empresa_regimen:           data.empresa_regimen           || '',
        empresa_tipo_persona:      data.empresa_tipo_persona      || '',
        empresa_ciiu:              data.empresa_ciiu              || '',
        empresa_actividad_desc:    data.empresa_actividad_desc    || '',
        empresa_ica_tarifa:        data.empresa_ica_tarifa        || '',
        empresa_responsabilidades: data.empresa_responsabilidades || '',
        empresa_logo_url:          data.empresa_logo_url          || '',
      }));
    } catch {}
  };

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSave = async () => {
    setSaving(true);
    setMsg(null);
    try {
      const payload = { ...form };
      // No enviar la máscara como contraseña real
      if (payload.smtp_pass === '••••••••') delete payload.smtp_pass;
      await api.put('/configuracion', payload);
      guardarEmpresaLocal(form);
      setMsg({ ok: true, text: '✅ Configuración guardada correctamente' });
    } catch (e) {
      setMsg({ ok: false, text: '❌ ' + (e.response?.data?.error || e.message) });
    } finally {
      setSaving(false);
      setTimeout(() => setMsg(null), 4000);
    }
  };

  const handleTestSMTP = async () => {
    setTesting(true);
    setTestMsg(null);
    try {
      const r = await api.get('/email/verificar');
      setTestMsg({ ok: r.data.ok, text: r.data.ok ? '✅ ' + r.data.mensaje : '❌ ' + r.data.error });
    } catch (e) {
      setTestMsg({ ok: false, text: '❌ ' + (e.response?.data?.error || e.message) });
    } finally {
      setTesting(false);
    }
  };

  if (loading) return <div style={{ color:'#64748b', textAlign:'center', padding:60 }}>Cargando...</div>;

  return (
    <div style={{ maxWidth: 760 }}>
      <div style={s.pageHeader}>
        <div>
          <h1 style={s.h1}>Configuración</h1>
          <p style={s.sub}>Datos de la empresa, correo y preferencias del sistema</p>
        </div>
        {tab !== 'recepcion' && (
          <button style={{ ...s.btnPrimary, opacity: saving ? 0.7 : 1 }} onClick={handleSave} disabled={saving}>
            {saving ? 'Guardando...' : '💾 Guardar cambios'}
          </button>
        )}
      </div>

      {msg && (
        <div style={{ ...s.alert, background: msg.ok ? '#14532d' : '#450a0a', borderColor: msg.ok ? '#16a34a' : '#dc2626' }}>
          {msg.text}
        </div>
      )}

      {/* Tabs */}
      <div style={s.tabs}>
        {TABS.map(t => (
          <button key={t.id} style={{ ...s.tab, ...(tab === t.id ? s.tabActive : {}) }} onClick={() => setTab(t.id)}>
            {t.label}
          </button>
        ))}
      </div>

      <div style={s.card}>

        {/* ── Pestaña EMPRESA ──────────────────────────────────────── */}
        {tab === 'empresa' && (
          <>
            <div style={s.sectionTitle}>Información de la empresa</div>
            <p style={s.hint}>Estos datos aparecerán en los documentos impresos (PDF) y en los correos enviados a clientes.</p>

            <div style={s.row2}>
              <Field label="Nombre / Razón social *" value={form.empresa_nombre}
                onChange={v => set('empresa_nombre', v)} placeholder="Ej: Ingeniería XYZ S.A.S" />
              <Field label="NIT" value={form.empresa_nit}
                onChange={v => set('empresa_nit', v)} placeholder="Ej: 900.123.456-7" />
            </div>
            <div style={s.row2}>
              <Field label="Teléfono" value={form.empresa_telefono}
                onChange={v => set('empresa_telefono', v)} placeholder="+57 300 000 0000" />
              <Field label="Ciudad" value={form.empresa_ciudad}
                onChange={v => set('empresa_ciudad', v)} placeholder="Bogotá, Colombia" />
            </div>
            <Field label="Correo corporativo" value={form.empresa_email}
              onChange={v => set('empresa_email', v)} placeholder="contacto@empresa.com" />
            <Field label="Dirección" value={form.empresa_direccion}
              onChange={v => set('empresa_direccion', v)} placeholder="Calle 10 # 20-30, Bogotá" />
            <Field label="Slogan / descripción corta" value={form.empresa_slogan}
              onChange={v => set('empresa_slogan', v)} placeholder="Soluciones de ingeniería de alta calidad" />
            {/* Logo */}
            <div style={{ marginTop:12 }}>
              <label style={s.label}>Logo de la empresa</label>
              <div style={{ display:'flex', alignItems:'center', gap:16, marginTop:6 }}>
                {/* Preview */}
                <div style={{ width:110, height:80, borderRadius:8, border:'2px dashed #334155', background:'#0f172a', display:'flex', alignItems:'center', justifyContent:'center', overflow:'hidden', flexShrink:0 }}>
                  {form.empresa_logo_url
                    ? <img src={form.empresa_logo_url.startsWith('http') ? form.empresa_logo_url : `${API_BASE}${form.empresa_logo_url}`}
                        alt="Logo" style={{ maxWidth:'100%', maxHeight:'100%', objectFit:'contain' }}
                        onError={e => { e.target.style.display='none'; }} />
                    : <span style={{ color:'#475569', fontSize:11, textAlign:'center', padding:8 }}>Sin logo</span>
                  }
                </div>
                <div style={{ flex:1 }}>
                  <input type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml"
                    style={{ display:'none' }} id="logo-upload"
                    onChange={async (e) => {
                      const file = e.target.files[0];
                      if (!file) return;
                      const fd = new FormData();
                      fd.append('logo', file);
                      try {
                        const token = localStorage.getItem('erp_token');
                        const r = await fetch(`${API_BASE}/api/configuracion/upload-logo`, {
                          method: 'POST', headers: { Authorization: `Bearer ${token}` }, body: fd,
                        });
                        const d = await r.json();
                        if (d.url) { set('empresa_logo_url', d.url); setMsg({ ok:true, text:'✅ Logo subido correctamente' }); setTimeout(()=>setMsg(null),3000); }
                        else setMsg({ ok:false, text:'❌ ' + (d.error || 'Error al subir logo') });
                      } catch { setMsg({ ok:false, text:'❌ Error al subir el logo' }); }
                      e.target.value = '';
                    }}
                  />
                  <label htmlFor="logo-upload" style={{ display:'inline-block', cursor:'pointer', padding:'8px 16px', background:'#1e3a8a', color:'#fff', borderRadius:8, fontSize:13, fontWeight:600 }}>
                    📁 Seleccionar imagen
                  </label>
                  <p style={{ ...s.hint, marginTop:6 }}>PNG, JPG, WEBP o SVG · Máx. 2 MB · Recomendado: fondo transparente</p>
                  {form.empresa_logo_url && (
                    <button onClick={() => { set('empresa_logo_url', ''); }}
                      style={{ marginTop:4, background:'none', border:'none', color:'#ef4444', fontSize:12, cursor:'pointer', padding:0 }}>
                      🗑️ Quitar logo
                    </button>
                  )}
                </div>
              </div>
            </div>
          </>
        )}

        {/* ── Pestaña DIAN ────────────────────────────────────────── */}
        {tab === 'dian' && (
          <>
            <div style={s.sectionTitle}>Factura Electrónica DIAN</div>
            <p style={s.hint}>La habilitación (certificado digital y software) la configura el administrador de la plataforma. Aquí solo sincronizás tu resolución de facturación directamente con la DIAN.</p>

            <div style={{ ...s.sectionTitle, fontSize:13, color:'#94a3b8', marginTop:16 }}>Estado de habilitación</div>
            <div style={s.infoBox}>
              <div style={{ display:'flex', gap:28, flexWrap:'wrap' }}>
                <div><div style={{ color:'#64748b', fontSize:12 }}>Certificado digital</div><div style={{ color: certMeta?.cargado ? '#10b981' : '#f59e0b', fontWeight:600, fontSize:13 }}>{certMeta?.cargado ? '✅ Configurado' : '⚠️ Pendiente'}</div></div>
                <div><div style={{ color:'#64748b', fontSize:12 }}>Software DIAN</div><div style={{ color: form.software_id ? '#10b981' : '#f59e0b', fontWeight:600, fontSize:13 }}>{form.software_id ? '✅ Configurado' : '⚠️ Pendiente'}</div></div>
                <div><div style={{ color:'#64748b', fontSize:12 }}>Ambiente</div><div style={{ color:'#e2e8f0', fontWeight:600, fontSize:13 }}>{form.fe_ambiente === '1' ? 'Producción' : 'Pruebas'}</div></div>
              </div>
              {(!certMeta?.cargado || !form.software_id) && (
                <p style={{ color:'#94a3b8', fontSize:12, margin:'10px 0 0' }}>Falta habilitación. Pedile al administrador de la plataforma que cargue el certificado y el software de tu empresa.</p>
              )}
            </div>

            <div style={{ ...s.sectionTitle, fontSize:13, color:'#94a3b8', marginTop:20 }}>Resolución de facturación</div>
            <div style={s.infoBox}>
              {form.resolucion_numero ? (
                <div style={{ fontSize:13, color:'#e2e8f0' }}>
                  <b>Prefijo {form.resolucion_prefijo || '—'}</b> · Resolución {form.resolucion_numero}<br />
                  <span style={{ color:'#94a3b8' }}>Rango {form.resolucion_desde}–{form.resolucion_hasta} · Vigencia {form.resolucion_fecha_desde || '—'} a {form.resolucion_fecha_hasta || '—'}</span>
                  {form.fe_clave_tecnica && <div style={{ color:'#10b981', fontSize:12, marginTop:4 }}>✅ Clave técnica cargada</div>}
                </div>
              ) : (
                <span style={{ color:'#94a3b8', fontSize:13 }}>Sin resolución sincronizada. Presioná el botón para traerla de la DIAN.</span>
              )}
            </div>
            <button style={{ ...s.btnPrimary, opacity: sincronizando ? 0.7 : 1 }} onClick={handleSincronizar} disabled={sincronizando}>
              {sincronizando ? 'Consultando a la DIAN…' : '🔄 Sincronizar resolución con la DIAN'}
            </button>
            {syncMsg && <p style={{ color: syncMsg.ok ? '#10b981' : '#f87171', fontSize:13, marginTop:8 }}>{syncMsg.text}</p>}
            <p style={{ ...s.hint, marginTop:10 }}>Consulta a la DIAN las resoluciones autorizadas de tu NIT (GetNumberingRange) y las carga automáticamente.</p>

            {proxNum && (
              <>
                <div style={{ ...s.sectionTitle, fontSize:13, color:'#94a3b8', marginTop:20 }}>Próximo número de factura</div>
                <div style={{ background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:12 }}>
                  <div style={{ display:'flex', gap:16, alignItems:'center', justifyContent:'space-between', flexWrap:'wrap' }}>
                    <div style={{ flex:'1 1 240px', color:'#94a3b8', fontSize:12, lineHeight:1.5 }}>
                      El prefijo y rango los fija la resolución (<b style={{ color:'#e2e8f0' }}>{proxNum.prefijo || '—'}</b> · {proxNum.desde}–{proxNum.hasta ?? '∞'}). Indicá desde qué número continúa.
                    </div>
                    <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                      <div style={{ display:'flex', alignItems:'stretch', background:'#1e293b', border:'1px solid #3b4a63', borderRadius:7, overflow:'hidden' }}>
                        <span style={{ display:'flex', alignItems:'center', padding:'0 10px', background:'#0b1220', color:'#94a3b8', fontSize:13, fontWeight:700, borderRight:'1px solid #3b4a63' }}>{proxNum.prefijo}-</span>
                        <input style={{ width:78, padding:'8px 10px', background:'transparent', border:'none', color:'#f1f5f9', fontSize:14, fontWeight:600, outline:'none' }}
                          type="number" min={proxNum.desde} max={proxNum.hasta || undefined} placeholder={String(proxNum.desde)}
                          value={proxInput} onChange={e => setProxInput(e.target.value)} />
                      </div>
                      <button style={{ background:'#1d4ed8', color:'#fff', border:'none', borderRadius:7, padding:'8px 18px', fontSize:13, fontWeight:600, cursor:'pointer', opacity: proxSaving ? 0.7 : 1 }} onClick={guardarProximo} disabled={proxSaving}>
                        {proxSaving ? '…' : 'OK'}
                      </button>
                    </div>
                  </div>
                  {!proxNum.enRango && (
                    <div style={{ color:'#fcd34d', fontSize:11.5, marginTop:8 }}>
                      ⚠️ Contador actual ({proxNum.proximo}) fuera de rango — fijá el número antes de facturar.
                    </div>
                  )}
                  {proxMsg && <p style={{ color: proxMsg.ok ? '#10b981' : '#f87171', fontSize:12.5, marginTop:8 }}>{proxMsg.text}</p>}
                </div>
              </>
            )}

            <div style={{ ...s.sectionTitle, fontSize:13, color:'#94a3b8', marginTop:20 }}>Información tributaria del emisor</div>
            <div style={s.row2}>
              <div style={s.field}>
                <label style={s.label}>Régimen fiscal</label>
                <select style={s.select} value={form.empresa_regimen} onChange={e => set('empresa_regimen', e.target.value)}>
                  <option value="Responsable de IVA">Responsable de IVA (Régimen común)</option>
                  <option value="No responsable de IVA">No responsable de IVA (Régimen simplificado)</option>
                </select>
              </div>
              <div style={s.field}>
                <label style={s.label}>Tipo de persona</label>
                <select style={s.select} value={form.empresa_tipo_persona} onChange={e => set('empresa_tipo_persona', e.target.value)}>
                  <option value="juridica">Persona jurídica</option>
                  <option value="natural">Persona natural</option>
                </select>
              </div>
            </div>
            <div style={s.row2}>
              <Field label="CIIU (actividad económica)" value={form.empresa_ciiu}
                onChange={v => set('empresa_ciiu', v)} placeholder="3314" />
              <Field label="Responsabilidades DIAN (separadas por ;)" value={form.empresa_responsabilidades}
                onChange={v => set('empresa_responsabilidades', v)} placeholder="O-13;O-15;O-23" />
            </div>
            <div style={s.row2}>
              <Field label="Descripción actividad económica" value={form.empresa_actividad_desc}
                onChange={v => set('empresa_actividad_desc', v)} placeholder="Mantenimiento y reparación especializado de equipo eléctrico" />
              <Field label="Tarifa ICA (por mil)" value={form.empresa_ica_tarifa}
                onChange={v => set('empresa_ica_tarifa', v)} placeholder="4" />
            </div>
          </>
        )}

        {/* ── Pestaña CORREO SMTP ──────────────────────────────────── */}
        {tab === 'correo' && (
          <>
            <div style={s.sectionTitle}>Configuración de correo (SMTP)</div>
            <p style={s.hint}>Configura el servidor de correo para el envío de cotizaciones y facturas. Para Gmail se recomienda usar una <strong style={{ color:'#93c5fd' }}>contraseña de aplicación</strong> (no la contraseña de cuenta).</p>

            <div style={s.infoBox}>
              <strong style={{ color:'#f59e0b', display:'block', marginBottom:8, fontSize:13 }}>
                ⚠️ Gmail requiere contraseña de aplicación — no acepta tu contraseña normal
              </strong>
              <ol style={{ color:'#94a3b8', fontSize:12, margin:0, paddingLeft:18, lineHeight:2 }}>
                <li>Activa la <strong style={{ color:'#f1f5f9' }}>verificación en 2 pasos</strong> en tu cuenta Google</li>
                <li>Ve a <strong style={{ color:'#f1f5f9' }}>myaccount.google.com → Seguridad → Contraseñas de aplicaciones</strong></li>
                <li>En "Seleccionar aplicación" elige <strong style={{ color:'#f1f5f9' }}>Otro</strong> y escribe "ERP"</li>
                <li>Copia la contraseña de <strong style={{ color:'#f1f5f9' }}>16 caracteres</strong> que te genera Google y pégala en el campo de abajo</li>
              </ol>
              <p style={{ color:'#64748b', fontSize:11, margin:'8px 0 0' }}>
                Host: smtp.gmail.com · Puerto: 587 · La contraseña de app tiene espacios pero funcionan igual
              </p>
            </div>

            <div style={s.row2}>
              <Field label="Servidor SMTP" value={form.smtp_host}
                onChange={v => set('smtp_host', v)} placeholder="smtp.gmail.com" />
              <Field label="Puerto" value={form.smtp_port} type="number"
                onChange={v => set('smtp_port', v)} placeholder="587" />
            </div>
            <Field label="Usuario / correo remitente" value={form.smtp_user}
              onChange={v => set('smtp_user', v)} placeholder="tucorreo@gmail.com" />
            <Field label="Contraseña de aplicación" value={form.smtp_pass} type="password"
              onChange={v => set('smtp_pass', v)} placeholder="Ingresa nueva contraseña para actualizar" />
            <Field label="Nombre y correo de origen (From)" value={form.smtp_from}
              onChange={v => set('smtp_from', v)} placeholder={`${form.empresa_nombre || 'ERP Ingeniería'} <tucorreo@gmail.com>`} />

            <div style={s.testArea}>
              <button style={{ ...s.btnSecondary, opacity: testing ? 0.7 : 1 }} onClick={handleTestSMTP} disabled={testing}>
                {testing ? 'Probando...' : '🔌 Probar conexión SMTP'}
              </button>
              {testMsg && (
                <span style={{ ...s.testResult, color: testMsg.ok ? '#10b981' : '#ef4444' }}>{testMsg.text}</span>
              )}
            </div>
          </>
        )}

        {/* ── Pestaña RECEPCIÓN DIAN ───────────────────────────────── */}
        {tab === 'recepcion' && <RecepcionConfig onMsg={setMsg} />}

        {/* ── Pestaña GENERAL ──────────────────────────────────────── */}
        {tab === 'general' && (
          <>
            <div style={s.sectionTitle}>Preferencias generales</div>
            <p style={s.hint}>Configura la moneda y el porcentaje de IVA que se aplicará en cotizaciones y facturas.</p>

            <Field
              label="URL del sistema (para links en emails)"
              value={form.site_url}
              onChange={v => set('site_url', v)}
              placeholder="Ej: http://192.168.1.10:3000 o https://erp.miempresa.com"
            />
            <p style={{ ...s.hint, marginTop:-10, marginBottom:16 }}>
              Esta URL se incluye en el email de propuesta para que el cliente pueda aprobar/rechazar. Usa la IP o dominio accesible desde internet.
            </p>

            <div style={{ ...s.sectionTitle, marginTop: 8 }}>Ventas y cobro</div>
            <div style={s.row2}>
              <div style={s.field}>
                <label style={s.label}>Moneda por defecto</label>
                <select style={s.select} value={form.moneda} onChange={e => set('moneda', e.target.value)}>
                  <option value="COP">COP — Peso colombiano</option>
                  <option value="USD">USD — Dólar americano</option>
                  <option value="EUR">EUR — Euro</option>
                </select>
              </div>
              <Field label="IVA por defecto (%)" value={form.iva_porcentaje} type="number"
                onChange={v => set('iva_porcentaje', v)} placeholder="19" />
              <Field label="Plazo de pago por defecto (días)" value={form.plazo_pago_dias} type="number"
                onChange={v => set('plazo_pago_dias', v)} placeholder="30" />
            </div>
            <p style={{ ...s.hint, marginTop:-8, marginBottom:16 }}>
              Se precargan al crear cotizaciones y facturas. El plazo calcula el vencimiento.
            </p>

            <div style={s.field}>
              <label style={s.label}>Condiciones comerciales por defecto</label>
              <textarea
                style={{ ...s.input, height:'auto', minHeight:90, padding:'8px 11px', resize:'vertical' }}
                value={form.condiciones_comerciales ?? ''}
                onChange={e => set('condiciones_comerciales', e.target.value)}
                placeholder="Ej: Precios en pesos, IVA incluido. Validez de la oferta 15 días…" />
              <span style={s.hint}>Texto que se precarga en las cotizaciones nuevas.</span>
            </div>

            <div style={s.infoBox}>
              <strong style={{ color:'#93c5fd', display:'block', marginBottom:4 }}>ℹ️ Nota</strong>
              <p style={{ color:'#94a3b8', fontSize:12, margin:0 }}>
                El cambio de IVA aplica solo a nuevos documentos. Las cotizaciones y facturas existentes
                conservan el IVA con el que fueron creadas.
              </p>
            </div>
          </>
        )}
      </div>

    </div>
  );
}

// Componente input reutilizable
function Field({ label, value, onChange, placeholder, type = 'text' }) {
  return (
    <div style={s.field}>
      <label style={s.label}>{label}</label>
      <input
        style={s.input}
        type={type}
        value={value ?? ''}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={type === 'password' ? 'new-password' : undefined}
      />
    </div>
  );
}

// Parámetros de recepción de facturas (DIAN): retenciones + responsable RADIAN.
// Guardan en tenant_config_contable vía /recepcion/retenciones-config (endpoint propio).
function RecepcionConfig({ onMsg }) {
  const [f, setF] = useState({ uvt: 52374, agente_reteiva: false, reteiva_pct: 15, reteica_tarifa: 0 });
  const [r, setR] = useState({ doc: '', nombres: '', apellidos: '', cargo: '', area: '' });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get('/recepcion/retenciones-config').then(({ data }) => {
      setF({ uvt: data.uvt || 52374, agente_reteiva: !!data.agente_reteiva, reteiva_pct: data.reteiva_pct ?? 15, reteica_tarifa: data.reteica_tarifa || 0 });
      const r0 = data.responsable || {};
      setR({ doc: r0.doc || '', nombres: r0.nombres || '', apellidos: r0.apellidos || '', cargo: r0.cargo || '', area: r0.area || '' });
    }).catch(() => {});
  }, []);

  const guardar = async () => {
    setBusy(true);
    try {
      await api.put('/recepcion/retenciones-config', { ...f, responsable: r });
      onMsg({ ok: true, text: '✅ Parámetros de recepción guardados' });
    } catch (e) {
      onMsg({ ok: false, text: '❌ ' + (e.response?.data?.error || 'No se pudo guardar') });
    } finally { setBusy(false); }
  };

  return (
    <>
      <div style={s.sectionTitle}>Retenciones (facturas recibidas)</div>
      <p style={s.hint}>Se aplican al causar las facturas de proveedores.</p>
      <div style={s.row2}>
        <Field label="Valor de la UVT" type="number" value={f.uvt} onChange={v => setF({ ...f, uvt: +v })} />
        <div style={s.field}>
          <label style={s.label}>¿Agente retenedor de IVA?</label>
          <select style={s.select} value={f.agente_reteiva ? '1' : '0'} onChange={e => setF({ ...f, agente_reteiva: e.target.value === '1' })}>
            <option value="0">No</option>
            <option value="1">Sí</option>
          </select>
        </div>
      </div>
      <div style={s.row2}>
        <Field label="% reteIVA" type="number" value={f.reteiva_pct} onChange={v => setF({ ...f, reteiva_pct: +v })} />
        <Field label="Tarifa reteICA (por mil)" type="number" value={f.reteica_tarifa} onChange={v => setF({ ...f, reteica_tarifa: +v })} />
      </div>

      <div style={{ ...s.sectionTitle, marginTop: 22 }}>Responsable de eventos RADIAN</div>
      <p style={s.hint}>Persona que firma el acuse/recibo ante la DIAN.</p>
      <div style={s.row2}>
        <Field label="Cédula" value={r.doc} onChange={v => setR({ ...r, doc: v })} />
        <Field label="Cargo" value={r.cargo} onChange={v => setR({ ...r, cargo: v })} />
        <Field label="Nombres" value={r.nombres} onChange={v => setR({ ...r, nombres: v })} />
        <Field label="Apellidos" value={r.apellidos} onChange={v => setR({ ...r, apellidos: v })} />
      </div>
      <Field label="Área / departamento" value={r.area} onChange={v => setR({ ...r, area: v })} />

      <div style={{ marginTop: 18 }}>
        <button style={{ ...s.btnPrimary, opacity: busy ? 0.7 : 1 }} disabled={busy} onClick={guardar}>
          {busy ? 'Guardando…' : '💾 Guardar recepción'}
        </button>
      </div>
    </>
  );
}

const s = {
  pageHeader:   { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:20 },
  h1:           { color:'#f1f5f9', fontSize:24, fontWeight:700, margin:'0 0 4px' },
  sub:          { color:'#64748b', fontSize:14, margin:0 },
  btnPrimary:   { background:'#1d4ed8', color:'#fff', border:'none', borderRadius:8, padding:'10px 22px', fontSize:14, fontWeight:600, cursor:'pointer' },
  btnSecondary: { background:'#334155', color:'#cbd5e1', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, cursor:'pointer' },
  alert:        { borderRadius:8, padding:'12px 18px', marginBottom:16, border:'1px solid', color:'#f1f5f9', fontSize:13, fontWeight:500 },
  tabs:         { display:'flex', gap:4, marginBottom:0, borderBottom:'1px solid #334155' },
  tab:          { background:'transparent', border:'none', borderBottom:'2px solid transparent', color:'#64748b', padding:'10px 18px', fontSize:13, cursor:'pointer', fontWeight:500 },
  tabActive:    { color:'#f1f5f9', borderBottomColor:'#3b82f6' },
  card:         { background:'#1e293b', borderRadius:'0 12px 12px 12px', padding:'28px 32px', border:'1px solid #334155', borderTop:'none' },
  sectionTitle: { color:'#f1f5f9', fontSize:16, fontWeight:700, marginBottom:6 },
  hint:         { color:'#64748b', fontSize:13, margin:'0 0 20px' },
  infoBox:      { background:'#0f172a', borderRadius:10, padding:'16px 20px', border:'1px solid #334155', marginBottom:20, marginTop:4 },
  row2:         { display:'grid', gridTemplateColumns:'1fr 1fr', gap:20 },
  field:        { marginBottom:18 },
  label:        { display:'block', color:'#94a3b8', fontSize:12, marginBottom:4, fontWeight:500 },
  input:        { width:'100%', padding:'10px 14px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', outline:'none' },
  select:       { width:'100%', padding:'10px 14px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', cursor:'pointer' },
  testArea:     { display:'flex', alignItems:'center', gap:16, marginTop:8 },
  testResult:   { fontSize:13, fontWeight:500 },
  logoPreview:  { marginTop:8 },
};
